export default __webpack_public_path__ + "static/media/B-Standard.db6fd0b6.png";